// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Part } from './part';
import { PartConfiguration } from './part-configuration';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class PartConfigurationLine extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  created!: Date;
  deleted?: Date;
  description?: string;
  partConfigurationId!: number;
  partId?: number;
  partNumber?: string;
  quantity?: number;
  part!: Part;
  partConfiguration!: PartConfiguration;
}

